import { SIGNUP, LOGIN, GOOGLE_LOGIN, GOOGLE_REGISTER, REQUEST_RESET } from './endpoints';
import createApiService from '../../http';

export const registerUserService = createApiService({
    endpoint: SIGNUP,
    method: 'post'
});

export const loginUserService = createApiService({
    endpoint: LOGIN,
    method: 'post',
});

export const loginWithGoogleService = createApiService({
    endpoint: GOOGLE_LOGIN,
    method: 'post',
})

export const registerWithGoogleService = createApiService({
    endpoint: GOOGLE_REGISTER,
    method: 'post',
})

export const requestPasswordResetService = createApiService({
    endpoint: REQUEST_RESET,
    method: 'post',
})